import Cookies from "js-cookie"; // eslint-disable-line no-restricted-imports

const SANDBOX_ENVIRONMENT_COOKIE = "notarize-sandbox-environment";
const ENABLED_VALUE = "enabled";

export function sandboxEnabled(): boolean {
  return Cookies.get(SANDBOX_ENVIRONMENT_COOKIE) === ENABLED_VALUE;
}

export function setSandboxEnabled(newValue: boolean): void {
  const { hostname, protocol } = window.location;
  const cookieAttrs = { domain: hostname, secure: /^https:/i.test(protocol) };
  if (newValue) {
    Cookies.set(SANDBOX_ENVIRONMENT_COOKIE, ENABLED_VALUE, cookieAttrs);
  } else {
    Cookies.remove(SANDBOX_ENVIRONMENT_COOKIE, cookieAttrs);
  }
  // This reload MUST happen when this is set, environment urls are not changed otherwise.
  window.location.reload();
}
